
<p-dropdown
        [options]="currencyList"
        [(ngModel)]="currency"
        (ngModelChange)="onCurrencyChange($event)"
        [placeholder]="placeholder"
        optionLabel="isoCode"
        optionValue="isoCode"
        [autoDisplayFirst]="false"
        [showClear]="true"
        appendTo="body"
        class="drop-dwn"
        [filter]="true"
        [filterBy]="'isoCode'"
        dropdownIcon="pi pi-chevron-down"
        [style]="{ width: '95px' }"
        [panelStyle]="{ width: '115px' }"
>
    <ng-template let-item pTemplate="item">
        <div>{{ item.isoCode || '' }}</div>
    </ng-template>
</p-dropdown>
